<!--suppress TypeScriptUnresolvedVariable -->
<div class="perm-admin-resources-container" *ngIf="isDefined(entityAssignable)">
    <ng-container *appVar="entityAssignable">
        <h1 *ngIf="hierarchyEntity" class="mat-h3 text-primary">
            <app-entity-path [path]="hierarchyEntity.path"></app-entity-path>
        </h1>
        <h1 *ngIf="!hierarchyEntity" class="mat-h3 text-primary">
            <app-icon name="fal-network-wired"></app-icon>&nbsp;&nbsp;
            {{'All resources selected'|i18n}}
        </h1>
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px" class="mb-16">
            <button *ngIf="entityAssignable" mat-stroked-button color="primary" class="new-assignment-button"
                    (click)="onClickNewAssignment()">
                <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
                {{'New assignment'|i18n}}
            </button>
            <!-- Button for root node creation only available under "true" root -->
            <button *ngIf="!hierarchyEntity && !hierarchy.root && canCreateRootNode"
                    mat-stroked-button color="primary"
                    (click)="onClickCreateRootNode()">
                <app-icon name="fal-network-wired"></app-icon>&nbsp;&nbsp;
                {{'New client (root node)'|i18n}}
            </button>
            <button *ngIf="rootNodeSelected" mat-stroked-button color="warn"
                    [disabled]="!canDeleteResource"
                    (click)="onClickDeleteResource()">
                <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
                {{'Delete client (root node)'|i18n}}
            </button>
        </div>
        <ng-container *ngIf="entityAssignable; else unassignableEntity">
            <div *ngIf="assignments; else loadingAssignments">
                <app-permission-assignments [readOnly]="!entityAssignable"
                                            [reactiveSubject]="true"
                                            [hideObject]="true"
                                            [assignments]="assignments"
                                            (subjectClick)="onClickSubjectAssignments($event)">
                </app-permission-assignments>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #subjectAssignments let-data>
    <h1 mat-dialog-title *ngIf="data.hint">{{'Permission assignments for {0}'|i18n:data.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-subject-permissions [subject]="[data.subjectType, data.subjectId]">
        </app-subject-permissions>
    </div>
</ng-template>

<ng-template #newAssignment let-data>
    <h1 mat-dialog-title>{{'New permission assignment on {0}'|i18n:data.object.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-new-permission-assignment [subjectType]="data.subjectType"
                                       [object]="data.object"
                                       (assignment)="data.assignment = $event"
                                       (valid)="data.valid = $event"
                                       (dirty)="data.dirty = $event">
        </app-new-permission-assignment>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary"
                [disabled]="!data.valid || !data.dirty"
                [mat-dialog-close]="data.assignment">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #unassignableEntity>
    <div fxLayout="row" fxLayoutAlign="center">
        <span *ngIf="hierarchyEntity">
            {{'Insufficient permissions to assign permissions on this resource'|i18n}}
        </span>
        <span *ngIf="!hierarchyEntity">
            {{'Insufficient permissions to assign permissions on all resources'|i18n}}
        </span>
    </div>
</ng-template>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>

<ng-template #newRootNode let-data>
    <h1 mat-dialog-title>{{'New root node'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <mat-form-field *appVar="entityNameError(data.name) as nameError">
            <input matInput [formControl]="data.name" placeholder="{{'Name'|i18n}}"
                   [maxlength]="ENTITY_NAME_MAX_LENGTH">
            <mat-error *ngIf="nameError === 'duplicate'">
                {{'Resource {0} already exists'|i18n:data.name.value.trim()}}
            </mat-error>
            <mat-error *ngIf="nameError === 'pattern'">
                {{'Root node name can only contain letters, numbers, _, -, and spaces'|i18n}}
            </mat-error>
            <mat-error *ngIf="nameError === 'invalid'">
                {{'Invalid name'|i18n}}
            </mat-error>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" [disabled]="!data.name.valid"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>


<ng-template #deleteResource>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:(hierarchyEntity.path|nicePath)}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:(hierarchyEntity.path|nicePath:false)}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>
